var nav_animation = sessionStorage.getItem("nav-animation");
var header = document.querySelector('header'); //if the user is visiting the site for the first time, add the animation class

if (!nav_animation) {
  header.classList.add('first-visit-animation');
  setTimeout(function () {
    //remove the animation class
    header.classList.remove('first-visit-animation'); //make the header visible

    header.classList.remove('opacity-0'); //set the session storage to true

    sessionStorage.setItem("nav-animation", "true");
  }, 1000);
} else {
  //otherwise this is not their first visit
  //remove the opacity
  header.classList.remove('opacity-0');
}